import React from 'react';
import AboutMe from '../images/mainhouse.jpeg';

function AboutPage() {
    return (
      <div id="aboutus">
        <div className="aboutCompany"  style={{fontFamily: 'Roboto',fontWeight: '400'}}>
          <div className="PageIntroBanner_header"><div className="row p-lg-5" style={{marginRight:"15px"}}>
              <div className="col-lg-10 mx-auto text-center" ><h2 style={{color:"#002856"}}>About</h2><h3 style={{color:"#002856"}}>The Company</h3></div></div>
          </div>

          <div className="row"  style={{margin: "0"}}>
            <div className="PageIntroBanner_wrapper">
              <div className="container">
                <div className="row">
                  <div
                    className="col-xl-7 order-xl-1 result-content"
                    style={{
                      padding: "50px 70px 30px 70px",
                      position: "relative",
                      width: "100%",
                      border: "2px solid #f0f0f0",
                      borderRight: 0
                    }}>
                  
                  <p style={{fontSize: "20px",color:"#002856"}}>
                      AASH Builders was started in 2008 by KMA Thangal. Prior to
                      starting AASH Builders, he worked in landscape contracting and
                      site development. AASH Builders grew into a premier, local
                      builder in Thrissur District. 
                      With our diverse portfolio, we have grown
                      to be a respected land developer in Kattoor Panchayat. 
                      Apart from building residents we also focused on creating floor plans to clients as well as designing interiors
                    </p>
                  </div>
                  <div
                    className="col-xl-5 order-xl-2 result-media-wrapper"
                    style={{padding: "60px 60px 30px 0px", minHeight: "400px", maxWidth: "100%", position: "relative"}}>

                    <div className="VideoModal_wrapper">
                      <span role="button" tabindex="0" className="VideoModal_btn"
                        ><img
                          src={AboutMe}
                          alt=""
                          className="w-100 VideoImageOverlay"
                          style={{
                            height:"40vh",
                            objectFit: "cover",
                            verticalAlign: "middle",
                            width: "100%"
                          }}
                      /></span>
                    </div>
                  </div>
                </div>
                <div
                  className="inset-dropshadow"
                  style={{
                    position: "absolute",
                    zIndex: 1,
                    boxShadow: "0 15px 30px 0 rgba(0, 0, 0, 0.15)",
                    bottom: 0,
                    height: "100px",
                    left: "2%",
                    right: "2%"
                  }}></div>
              </div>
            </div>
          </div>
    </div>
  </div>
    );

}

export default AboutPage;